<script>

export default {
    name: 'home',

    watch:
    {
        '$route':
        {
            handler()
            {
                if(this.$route.params.locale)
                {
                    this.$store.dispatch('localeSet', this.$route.params.locale)
                } else {
                    this.$router.replace({ name: 'home', params: { locale: 'en' } })
                }
            },
            immediate: true
        }
    },

    mounted()
    {
        const vid = document.getElementById("myVideo")
        vid.play()
    }
}
</script>

<template lang="pug">
    .home
        justfit-section.hero(noPad fluid)
            video#myVideo.w-100.home-hero-video.d-none.d-lg-inline(loop muted)
                source(type="video/mp4" :src="require(`@/assets/img/video.mp4`)")
            .hero-content
                .container
                    .row.justify-content-center
                        .col-md-8
                            justfit-heading.mb-3.green-box.d-none.d-md-block(:level="2") {{ $t('BASE.FIWE_FEVER') }}
                            justfit-heading.font-weight-heavy.heading-helper {{ $t('BASE.EXPERIENCE') }}
                            .epic {{ $t('BASE.FIWE') }}
                            .font-weight-bold(v-html="$t('BASE.DATE') ")
                            .row.d-lg-none.d-block.my-3
                                .col-md-10.col-11
                                    a(href="https://www.youtube.com/watch?v=JvVOYfH-GU8" target="_blank")
                                        .youtube-box.d-flex.align-items-center.py-2.px-3
                                            justfit-image.mr-3(:src="require(`@/assets/img/youtube.png`)")
                                            .font-italic.font-weight-semibold.fs-18 {{ $t('BASE.YOUTUBE_TEXT') }}
                            .text-center.d-none.d-md-block
                                a(href="#product")
                                    justfit-image.mt-5(:src="require(`@/assets/img/down_arrow.png`)")
        justfit-section.product#product
            .row.align-items-center
                .col-lg-6.col-md-8
                    justfit-heading.mb-5.heading-helper(:level="2") {{ $t('BASE.SAVE_IT') }}
                    justfit-heading.mr-auto.w-lg-75(:level="4") {{ $t('BASE.JUSTFIT_LITE_PRICE') }}
                    .text-center.my-5.d-block.d-md-none
                        justfit-image.image-helper(:src="require(`@/assets/img/suit_mobil.png`)")
                        .text-center.font-weight-bold.my-5.fs-18(v-html="$t('BASE.JUSTFITPRO_PRICE')")
                    .row
                        .col-md-6
                            .text-center
                                justfit-image.mt-5.w-lg-75.mx-auto(:src="require(`@/assets/img/man.png`)")
                            p {{ $t('BASE.CONCEPT') }}
                        .col-md-6
                            .text-center
                                justfit-image.mt-5.w-lg-75.mx-auto(:src="require(`@/assets/img/rocket.png`)")
                            p {{ $t('BASE.SYSTEM') }}
                        .col-md-6
                            .text-center
                                justfit-image.mt-5.w-lg-75.mx-auto(:src="require(`@/assets/img/hands.png`)")
                            p {{ $t('BASE.SERVICE') }}
                        .col-md-6
                            .text-center
                                justfit-image.mt-5.w-lg-75.mx-auto(:src="require(`@/assets/img/edit.png`)")
                            p {{ $t('BASE.CUSTOMIZED_PRODUCT') }}
                .col-lg-6.col-md-4.d-none.d-md-block
                    justfit-image.mt-5.w-lg-75.mx-auto(:src="require(`@/assets/img/product.png`)")
                    .text-center.font-weight-bold.my-5.fs-18(v-html="$t('BASE.JUSTFITPRO_PRICE')")
                .col-12.pt-5
                    p.mb-5 {{ $t('BASE.APPOINTMENT') }}
                    justfit-button.d-inline-block(variant="gradient" href="#form" small) {{ $t('BASE.INTERESTED') }}
        justfit-section.experience
            .row
                .col-12
                    justfit-heading.text-uppercase.heading-helper(:level="2") {{ $t('BASE.JUSTFIT_EXPERIENCE') }}
            .row.justify-content-center.mb-5
                .col-md-4
                    .text-center.text-md-left
                        justfit-image(:src="require(`@/assets/img/people.png`)")
                    justfit-heading.mb-4(:level="3") {{ $t('BASE.TRAININGS') }}
                    p {{ $t('BASE.TRAININGS_TEXT') }}
                .col-md-2
                .col-md-4
                    .text-center.text-md-left
                        justfit-image(:src="require(`@/assets/img/talk.png`)")
                    justfit-heading.mb-4(:level="3") {{ $t('BASE.PRESENTATION') }}
                    p {{ $t('BASE.PRESENTATION_TEXT') }}
            .row
                .col-12.text-center
                    p.mb-5 {{ $t('BASE.APPOINTMENT') }}
                    justfit-button.d-inline-block(variant="gradient" href="#form" small) {{ $t('BASE.INTERESTED') }}
        justfit-section.form-section#form
            .text-center
                justfit-heading.mb-5(:level="2") {{ $t('BASE.FORM_TITLE') }}
            .row.justify-content-center
                .col-lg-8.col-md-10.col-12
                    p {{ $t('BASE.FORM_TEXT') }}
            .row.justify-content-center
                .col-lg-6.col-md-8.col-12
                    justfit-forminho.my-5
                    p {{ $t('BASE.CONTACT_TEXT') }}
                    .row
                        .col-md-6.d-flex.align-items-center
                            justfit-image(:src="require(`@/assets/img/phone.png`)")
                            a(href="tel:+36706669988") +36-70-666-9988
                        .col-md-6.d-flex.align-items-center
                            justfit-image(:src="require(`@/assets/img/email.png`)")
                            a(href="mailto:+info@justfitart.com") info@justfitart.com
</template>

<style lang="scss">
    @import "../../assets/styles/settings/settings";
    .hero {
        position: relative;
        padding: 0;
        @media(max-width: 992px)
        {
            background-image: url('../../assets/img/hero_tablet.jpg');
            padding-top: 28vw;
        }
        @media(max-width: 768px)
        {
            background-image: url('../../assets/img/hero_mobile.jpg');
            background-position: top;
            padding-top: 80vw;
        }
        .youtube-box {
            background-color: #003f49;
        }
        .hero-content {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding-top: 10vw;
            padding-bottom: 5vw;
            @media(max-width: 992px)
            {
                position: relative;
            }
            a {
                text-decoration: none;
            }
            @media(max-width: 768px)
            {
                .heading-helper {
                    font-size: rem(28);
                }
            }
        }
        .green-box {
            display: inline-block;
            margin-left: auto;
            background-color: $justfit-green;
            font-style: italic;
            padding: rem(4) rem(24);
            color: black;
            @media(max-width: 768px)
            {
                font-size: rem(16) !important;
                padding: 0 0.25rem;
                &.orosz {
                    font-size: rem(14) !important;
                    line-height: 1.1;
                    text-align: left;
                }
            }
        }
        .epic {
            position: relative;
            font-size: rem(160);
            @media(max-width: 1200px)
            {
                font-size: rem(120);
            }
            @media(max-width: 768px)
            {
                font-size: rem(120);
                &.orosz {
                    font-size: rem(50);
                }
            }
            font-weight: bold;
            line-height: 1;
            text-shadow: rem(7) 0 rem(1) #E9F145, 
                rem(7) rem(7) rem(20) rgba(207, 221, 44, 0.75),
                rem(7) rem(-7) rem(20) rgba(207, 221, 44, 0.75),
                rem(-7) rem(7) rem(20) rgba(207, 221, 44, 0.75),
                rem(-7) rem(-7) rem(20) rgba(207, 221, 44, 0.75);
        }
    }
    .product {
        padding: 6vw 0;
        background-image: url('../../assets/img/bckgr.jpg');
        @media(max-width: 768px)
        {
            background-image: url('../../assets/img/product_bg_mobil.jpg');
            .heading-helper {
                font-size: rem(24);
                line-height: 1.2;
            }
            .image-helper {
                width: calc(100% + 30px);
                margin-left: rem(-15);
            }
        }
    }

    .experience {
        background-image: url('../../assets/img/third.jpg');
        padding: 6vw 0;
        @media(max-width: 768px)
        {
            background-position: top;
            background-image: url('../../assets/img/exp_mobil.jpg');
        }
        .heading-helper {
            margin-bottom: 50vw;
        }
    }

    .form-section {
        background-image: url('../../assets/img/formbg.jpg');
    }
</style>
